module.exports = __webpack_public_path__ + "static/media/pie.70b3ccc6.png";